export const ATTR_FIELDS = {
    DEFAULT_VALUE: 'defaultDisplayValue',
    LABEL: 'label',
    MESSAGE_TEXT: 'messageText',
    MESSAGE_HTML: 'messageHtml',
    SHOW: 'show',
};
export const marketingAttributeTypes = [
    {
        value: 'CUSTOMER_SERVICE_NUMBER',
        text: 'Customer Service Number',
        fields: [ATTR_FIELDS.SHOW, ATTR_FIELDS.MESSAGE_TEXT, ATTR_FIELDS.LABEL],
    },
    {
        value: 'OPENING_BID',
        text: 'Opening Bid',
        fields: [ATTR_FIELDS.SHOW, ATTR_FIELDS.LABEL, ATTR_FIELDS.DEFAULT_VALUE],
    },
    {
        value: 'RESERVE_AMOUNT',
        text: 'Reserve Amount',
        fields: [ATTR_FIELDS.SHOW, ATTR_FIELDS.LABEL, ATTR_FIELDS.DEFAULT_VALUE],
    },
    {
        value: 'TRUSTEE_SALE_NUMBER',
        text: 'Trustee Sale Number',
        fields: [ATTR_FIELDS.SHOW, ATTR_FIELDS.LABEL, ATTR_FIELDS.DEFAULT_VALUE],
    },
    {
        value: 'CONTACT',
        text: 'Contact (for Borrowers/Homeowners)',
        fields: [
            ATTR_FIELDS.SHOW,
            ATTR_FIELDS.DEFAULT_VALUE,
            ATTR_FIELDS.MESSAGE_TEXT,
            ATTR_FIELDS.LABEL,
        ],
    },
    {
        value: 'DEPOSIT_CHECK_VERBIAGE',
        text: 'Deposit Check Verbiage',
        fields: [ATTR_FIELDS.SHOW, ATTR_FIELDS.MESSAGE_TEXT, ATTR_FIELDS.LABEL],
    },
    {
        value: 'AUCTIONEER_DIALOGUE_CLEARANCE',
        text: 'Auctioneer Dialogue - Clearance',
        fields: [ATTR_FIELDS.MESSAGE_HTML],
    },
    {
        value: 'AUCTIONEER_DIALOGUE_POSTPONEMENT',
        text: 'Auctioneer Dialogue - Postponement',
        fields: [ATTR_FIELDS.MESSAGE_HTML],
    },
    {
        value: 'GENERAL_ANNOUNCEMENT',
        text: 'General Announcement',
        fields: [ATTR_FIELDS.MESSAGE_TEXT],
    },
    {
        value: 'AUCTIONEER_LICENSING',
        text: 'Auctioneer Licensing',
        fields: [ATTR_FIELDS.SHOW, ATTR_FIELDS.MESSAGE_TEXT],
    },
    {
        value: 'TRANSACTION_DETAILS',
        text: 'Transaction Details',
        fields: [ATTR_FIELDS.SHOW, ATTR_FIELDS.MESSAGE_HTML],
    },
    {
        value: 'ORIGINAL_PRINCIPAL_BALANCE',
        text: 'Original Principal Balance',
        fields: [ATTR_FIELDS.SHOW, ATTR_FIELDS.LABEL, ATTR_FIELDS.DEFAULT_VALUE],
    },
    {
        value: 'NOS_AMOUNT',
        text: 'Total Est Debt or NOS Amount',
        fields: [ATTR_FIELDS.SHOW, ATTR_FIELDS.LABEL, ATTR_FIELDS.DEFAULT_VALUE],
    },
    {
        value: 'FINAL_JUDGEMENT_AMOUNT',
        text: 'Final Judgement Amount',
        fields: [ATTR_FIELDS.SHOW, ATTR_FIELDS.LABEL, ATTR_FIELDS.DEFAULT_VALUE],
    },
    {
        value: 'SALES_AGENT_CONTACT',
        text: 'Sales Agent Contact',
        fields: [
            ATTR_FIELDS.SHOW,
            ATTR_FIELDS.DEFAULT_VALUE,
            ATTR_FIELDS.MESSAGE_TEXT,
            ATTR_FIELDS.LABEL,
        ],
    },
    {
        value: 'DISCLAIMER',
        text: 'Disclaimer',
        fields: [ATTR_FIELDS.SHOW, ATTR_FIELDS.MESSAGE_TEXT],
    },
    {
        value: 'REMOTE_BID',
        text: 'Remote Bid',
        fields: [ATTR_FIELDS.SHOW],
    },
].sort((a, b) => (a.text > b.text ? 1 : -1));
//# sourceMappingURL=marketingAttributeTypes.js.map